import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSlaveProduct() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      masterFaName: isEmpty(state.masterFaName),
      slaveFaName: isEmpty(state.slaveFaName),
    };

    setter(errorState);

    if (errorState.masterFaName || errorState.slaveFaName) {
      enqueueSnackbar("لطفا اطلاعات  را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getSlaveList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_SlaveProducts?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllSlaveList = (callback) => {
    MyAxios.get(`Admin_SlaveProducts?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addSlave = (slave, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(slave));
    MyAxios.post(`Admin_SlaveProducts`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteSlave = (id, callback) => {
    const data = new FormData();
    data.append("SlaveProductID", id);
    MyAxios.delete(`Admin_SlaveProducts`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getSlaveList,
    getAllSlaveList,
    validate,
    addSlave,
    deleteSlave,
  };
}
